import React from 'react';
import styles from './MeetingMotif.module.scss';
import MeetingIcon from './comment-regular.svg';

function MeetingMotif(props) {
    const { className = '', meeting } = props;

    if (!meeting.details) return null;

    return (
        <div className={[className, styles.MeetingMotif].join(' ')}>
            <MeetingIcon className={styles.icon} />
            {meeting.details}
        </div>
    );
}

export default MeetingMotif;
